import { Lead } from '../../components/typography/Heading';
import styles from './organization-header.module.less';
import { useEffect, useState } from 'react';
import ButtonText from '../../components/button/button-text/ButtonText';
import { updateOrganizationInfo } from '../organization-actions';
import { useDispatch } from 'react-redux';
import Counter from '../../components/counter/Counter';
import RoundedButtonSecondary from '../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import RoundedButtonPrimary from '../../components/button/rounded-button-primary/RoundedButtonPrimary';
import { Label, TextArea } from '@sb1/ffe-form-react';
import { WHITE_ORGANIZATION_COLOR } from '../theme/OrganizationTheme';
import Linkify from 'linkify-react';

const OrganizationLead = ({ organization, editable }) => {
    const [lead, setLead] = useState();
    const [editing, setEditing] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setLead(organization?.lead);
    }, [editable, organization?.lead]);

    const DisplayLead = () =>
        organization?.lead ? (
            <Lead className={[styles.lead, WHITE_ORGANIZATION_COLOR].join(' ')}>
                <Linkify>{organization.lead}</Linkify>
            </Lead>
        ) : null;

    const updateOrganizationLead = () => {
        dispatch(updateOrganizationInfo({ id: organization.id, lead }));
        setEditing(false);
    };

    if (!editable) {
        return (
            <div className={styles.organizationLead}>
                <DisplayLead />
            </div>
        );
    }
    if (editing) {
        return (
            <div className={styles.organizationLead}>
                <Label className={styles.label} htmlFor={'textarea-ingress'}>
                    Skriv en kort ingress
                </Label>
                <TextArea
                    onChange={(evt) => {
                        const text = evt.target.value;
                        const cleaned = text.replace('\n', ' ');
                        setLead(cleaned);
                    }}
                    placeholder={'Skriv litt om organisasjonen'}
                    value={lead}
                    id={'textarea-ingress'}
                    className={[styles.textArea, WHITE_ORGANIZATION_COLOR].join(' ')}
                    maxLength={255}
                />
                <Counter className={styles.counter} countLimit={255} currentCount={lead?.length || 0} />
                <div className={styles.editButtons}>
                    <ButtonText onClick={() => setEditing(false)}>Avbryt</ButtonText>
                    <RoundedButtonPrimary onClick={updateOrganizationLead}>Lagre</RoundedButtonPrimary>
                </div>
            </div>
        );
    }
    return (
        <div className={styles.organizationLead}>
            <DisplayLead />
            <RoundedButtonSecondary onClick={() => setEditing(true)}>
                <i className={'fa-regular fa-pen-to-square'} />{' '}
                {organization?.lead ? 'Rediger ingress' : 'Legg inn ingress'}
            </RoundedButtonSecondary>
        </div>
    );
};

export default OrganizationLead;
